import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ok-popup',
  templateUrl: './ok-popup.component.html',
  styleUrls: ['./ok-popup.component.scss']
})
export class OkPopupComponent {
  public msg: string ='';
  public buttonLabel: string = 'ok'
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OkPopupComponent>,
  ) {
    this.msg = data.msg;
    this.buttonLabel = data.buttonLabel;
  }

  ok() {
    this.dialogRef.close(true);
  }
}
